module.exports = __webpack_public_path__ + "img/actshop1.c7574951.jpg";